type DocType = { [key: string]: string };

type DataType = {
  field: string;
  row: number;
  dataSet: string;
  hits: number;
  docs: DocType[];
};

export const getNewDocs = (arr1: DataType[], arr2: DataType[]): DataType[] => {
  const arr1Map = new Map(arr1.map((item) => [ item.field, item ]));
  const result: DataType[] = [];

  for (const item2 of arr2) {
    const item1 = arr1Map.get(item2.field);

    if (!item1) {
      // If field is not in arr1, include the whole item2 object
      result.push(item2);
    } else {
      // Compare docs array
      const existingDocsSet = new Set(item1.docs.map((doc) => JSON.stringify(doc)));
      const newDocs = item2.docs.filter((doc) => !existingDocsSet.has(JSON.stringify(doc)));

      if (newDocs.length > 0) {
        result.push({
          field: item2.field,
          row: item2.row,
          dataSet: item2.dataSet,
          hits: newDocs.length,
          docs: newDocs,
        });
      }
    }
  }
  return result;
};
